import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "my-8" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "my-8" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "my-8" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "my-8" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "my-8" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "my-8" }
const _hoisted_16 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, {
      modelValue: _ctx.isFormValid,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isFormValid) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('children.createChildAccount')), 1)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.childcareType')) + "*", 1),
          _createVNode(_component_v_select, {
            rules: [_ctx.required],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            items: _ctx.childTypeOptions,
            "item-title": "label",
            "item-value": "value",
            modelValue: _ctx.childcareType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.childcareType) = $event))
          }, null, 8, ["rules", "items", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + "*", 1),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    label: _ctx.$t('common.lastName'),
                    modelValue: _ctx.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                    rules: [_ctx.required]
                  }, null, 8, ["label", "modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    label: _ctx.$t('common.firstName'),
                    modelValue: _ctx.firstName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.firstName) = $event)),
                    rules: [_ctx.required]
                  }, null, 8, ["label", "modelValue", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('children.nurseryCodeNumber')), 1),
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            label: _ctx.$t('children.optionalCode1'),
            modelValue: _ctx.optionalChildCode1,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.optionalChildCode1) = $event)),
            class: "mb-2"
          }, null, 8, ["label", "modelValue"]),
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            label: _ctx.$t('children.optionalCode2'),
            modelValue: _ctx.optionalChildCode2,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.optionalChildCode2) = $event))
          }, null, 8, ["label", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t('children.dateOfBirth')) + "*", 1),
          _createVNode(_component_date_picker, {
            modelValue: _ctx.dateOfBirth,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateOfBirth) = $event)),
            label: _ctx.$t('children.dateOfBirth'),
            rules: [_ctx.required]
          }, null, 8, ["modelValue", "label", "rules"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t('common.gender')) + "*", 1),
          _createVNode(_component_v_select, {
            rules: [_ctx.required],
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            items: _ctx.genderOptions,
            "item-title": "label",
            "item-value": "value",
            modelValue: _ctx.gender,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gender) = $event))
          }, null, 8, ["rules", "items", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t('children.admissionDate')) + "*", 1),
          _createVNode(_component_date_picker, {
            modelValue: _ctx.admissionDate,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.admissionDate) = $event)),
            label: _ctx.$t('children.admissionDate'),
            rules: [_ctx.required]
          }, null, 8, ["modelValue", "label", "rules"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.$t('children.graduationDate')), 1),
          _createVNode(_component_date_picker, {
            modelValue: _ctx.graduationDate,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.graduationDate) = $event)),
            label: _ctx.$t('children.graduationDate')
          }, null, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.extendedCarePattern')), 1),
          _createVNode(_component_v_select, {
            modelValue: _ctx.hoursPatternId,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.hoursPatternId) = $event)),
            items: _ctx.patternList,
            "item-title": "patternTitle",
            "item-value": "patternId",
            variant: "outlined",
            density: "compact",
            "hide-details": ""
          }, null, 8, ["modelValue", "items"])
        ]),
        _createElementVNode("div", null, [
          (_ctx.isCreating)
            ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                key: 0,
                indeterminate: "",
                color: "primary",
                class: "my-8"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            "x-large": "",
            onClick: _ctx.create,
            disabled: _ctx.isCreating || !_ctx.isFormValid
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_v_spacer)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}